import { 
  Back
} from "./style";

export default () => {
  return (
    <Back>
    </Back>
  )
}
